/* jshint esversion: 6 */
/* jshint ignore:start */
import './App.css';
import './css/Style.css';
import './css/Responsive.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Header from './component/Header';
import Dashboard from './component/Dashboard';
import Footer from './component/Footer';
import PaymentResponse from './Payment/PaymentResponse';
import CategoryDetails from './component/Lab/CategoryDetails';
import Shop from './component/Shop/Shop';
import LabDetails from './component/Lab/LabDetails';
import PackagesDetails from './component/Lab/PackagesDetails';
import CartBooking from './component/Lab/CartBooking';
import ShopList from './component/Shop/ShopList';
import StoreHomePage from './component/Shop/StoreHomePage';
import OurServices from './component/DocAppointment/OurServices';
import DocProfile from './component/DocAppointment/DocProfile';
import DocDetails from "./component/DocAppointment/DocDetail";
import Bookappoinment from './component/DocAppointment/Bookappointment';
import Checkout from './component/Shop/Checkout';
import Dashboard2 from './component/Profile/Dashboard';
import MyBooking from './component/Profile/MyBooking';
import MyOrder from './component/Profile/MyOrder';
import BookingDetails from './component/Profile/BookingDetails';
import OrderDetails from './component/Profile/OrderDetails';
import BookingPackage from './component/Profile/BookingPackage';
import PackageDetails from './component/Profile/PackageDetails';
import Wallet from './component/Profile/Wallet';
import Pages from './component/Profile/Pages';
import Chat from './component/Profile/Chat';
import ReferAndEarn from './component/Profile/ReferAndEarn';
import VideoCall from './component/Call/VideoCall';
import { Routes, Route, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { useContext, useEffect, useState } from 'react';
import { MyContext } from './Context/MyProvider';
import { socket } from './socket';
import Faq from './component/Profile/Faq';
import secureLocalStorage from "react-secure-storage";
function App() {

  const { showCall, setShowCall } = useContext(MyContext);

  const [callData, setCallData] = useState();
  const location = useLocation();

  useEffect(() => {

    const Userid = secureLocalStorage.getItem("Userid");

    if (!Userid) return;

    const handleNewChat = (msg) => {
      if (msg) {
        setShowCall(true);
        setCallData(msg);
      }
      // HandleCheckDevices(msg);
    };

    socket.on(`Other_Audio_Video_Call${Userid}`, handleNewChat);

    return () => {
      socket.off(`Other_Audio_Video_Call${Userid}`, handleNewChat);
    };

  }, []);

  const HandleCheckDevices = async (msg) => {
    try {
      const deviceList = await navigator.mediaDevices.enumerateDevices();

      let hasCamera = false;
      let hasMicrophone = false;

      deviceList.forEach(device => {
        if (device.kind === 'videoinput') {
          hasCamera = true;
        }
        if (device.kind === 'audioinput') {
          hasMicrophone = true;
        }
      });

      if (hasCamera && hasMicrophone) {
        if (msg) {
          setShowCall(true);
          setCallData(msg);
        }
      }

    } catch (error) {
      console.error('Error checking devices:', error);
    }
  }

  const hideFooter = location.pathname.startsWith("/dashbord");

  return (
    <div className='App'>

      <Header />
      <Routes>

        <Route path='/' element={<Dashboard />} />
        <Route path='/doctor-profile' element={<DocProfile />} />
        <Route path='/services' element={<OurServices />} />
        <Route path='/doctor-details' element={<DocDetails />} />
        <Route path='/book-appointment' element={<Bookappoinment />} />
        <Route path='/paymentresponse' element={<PaymentResponse />} />
        <Route path='/lab-details' element={<LabDetails />} />
        <Route path='/category-details' element={<CategoryDetails />} />
        <Route path='/packages' element={<PackagesDetails />} />
        <Route path='/cart-booking' element={<CartBooking />} />
        <Route path='/shop' element={<Shop />} />
        <Route path='/shop-list' element={<ShopList />} />
        <Route path='/store-home' element={<StoreHomePage />} />
        <Route path='/checkout' element={<Checkout />} />
        <Route path='/bokking' element={<MyBooking />} />
        <Route path=":title" element={<Pages />} />

        {/* Nested routes */}
        <Route path="/dashbord" element={<Dashboard2 />}>
          <Route path='booking' element={<MyBooking />} />
          <Route path='order' element={<MyOrder />} />
          <Route path='appointment-details' element={<BookingDetails />} />
          <Route path='order-details' element={<OrderDetails />} />
          <Route path='booking-package' element={<BookingPackage />} />
          <Route path='package-details' element={<PackageDetails />} />
          <Route path='wallet' element={<Wallet />} />
          <Route path='faq' element={<Faq />} />
          <Route path=":title" element={<Pages />} />
          <Route path="chat" element={<Chat />} />
          <Route path="refer-and-earn" element={<ReferAndEarn />} />
        </Route>
      </Routes>

      {!hideFooter && <Footer />}

      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      {showCall && (
        <div className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
          <div className="audio_box">
            <VideoCall Data={callData} />
          </div>
        </div>
      )}

    </div>
  );
}

export default App;
/* jshint ignore:end */
